import { regexEmail, regexNumero } from "global/utils/expresionesRegulares";
import InputV1 from "../InputV1/InputV1";
import {
  BodyEnviarOrden,
  BtnSubirOrden,
  ContainerEnviarOrden,
  InputContainer,
  ModalHeaderCross,
  ModalHeaderCrossX,
  ModalHeaderCrossY,
  TopEnviarOrden,
} from "./localStyle";
import { useContext, useEffect, useState } from "react";
import EnviarMailIcon from "_+_Portal/assets/images/generico/EnviarMailIcon";
import PhoneIcon from "_+_Portal/assets/images/generico/PhoneIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import camelize from "global/utils/camelize";
import { wsGetDatosPaciente } from "_+_Portal/context/Actions/paciente/paciente";

const EnviarOrden = ({ subirOrden, dissmiss }) => {
  const { pacienteState, selectDropDownState, pacienteDispatch } =
    useContext(PortalContext);
  const [checkError, setCheckError] = useState(false);
  const [formularioPerfil, setformularioPerfil] = useState({
    nombre: pacienteState.paciente.datosActualizados.nombre,
    domicilio: camelize(pacienteState.paciente.datosActualizados.domicilio),
    telefono: pacienteState.paciente.datosActualizados.telefono,
    codigo_postal: pacienteState.paciente.datosActualizados.codigo_postal,
    fecha_nacimiento: pacienteState.paciente.datosActualizados.fecha_nacimiento,
    sexo: pacienteState.paciente.datosActualizados.sexo,
    email: pacienteState.paciente.datosActualizados.email,
    telefono_movil: pacienteState.paciente.datosActualizados.telefono_movil,
    idlocalidad: pacienteState.paciente.datosActualizados.idlocalidad,
    localidad_desc: camelize(
      pacienteState.paciente.datosActualizados.localidad
    ),
    cobertura: {
      OSInactiva: pacienteState.paciente.datosActualizados.cobertura.osInactiva,
      OSNoDaConsulta:
        pacienteState.paciente.datosActualizados.cobertura.osNoDaConsulta,
      OSNoDaEstudios:
        pacienteState.paciente.datosActualizados.cobertura.osNoDaEstudios,
      PlanInactivo:
        pacienteState.paciente.datosActualizados.cobertura.planInactivo,
      idCobertura:
        pacienteState.paciente.datosActualizados.cobertura.idCobertura,
      idCoberturaPlan:
        pacienteState.paciente.datosActualizados.cobertura.idCoberturaPlan,
      cobertura: pacienteState.paciente.datosActualizados.cobertura.cobertura,
      plan: pacienteState.paciente.datosActualizados.cobertura.plan,
      afiliado: pacienteState.paciente.datosActualizados.cobertura.afiliado,
    },
  });

  const onChangeInput = (e) => {
    if (e.target.name === "email") {
      setCheckError(isErrorEmail(e.target.value));
    }
    setformularioPerfil({
      ...formularioPerfil,
      [e.target.name]: e.target.value,
    });
  };

  const isErrorEmail = (email) => {
    if (!regexEmail.test(email)) {
      return true;
    }
    if (email === "") {
      return true;
    }
    return false;
  };

  return (
    <ContainerEnviarOrden>
      <TopEnviarOrden>
        <p className="rb18b">Verificación de datos</p>
        <ModalHeaderCross onClick={dissmiss}>
          <ModalHeaderCrossX></ModalHeaderCrossX>
          <ModalHeaderCrossY></ModalHeaderCrossY>
        </ModalHeaderCross>
      </TopEnviarOrden>
      <BodyEnviarOrden>
        <p className="rb18b c-latex10 tituloDatos">
          Verifique sus datos de contacto por donde lo contactaremos
        </p>
        <InputContainer>
          <div className="iconoTextoContainer">
            <PhoneIcon
              color={"var(--color-latex10)"}
              width={16}
              height={16}
            ></PhoneIcon>
            <p>Teléfono móvil</p>
          </div>
          <InputV1
            inputType="number"
            placeholderText={"1165499481"}
            errorStr={"El telefono es requerido"}
            onChange={onChangeInput}
            // checkError={checkError}
            className={"inputNonScroll"}
            isRequired={true}
            name="telefono_movil"
            value={formularioPerfil.telefono_movil}
          />
        </InputContainer>
        <InputContainer>
          <div className="iconoTextoContainer">
            <EnviarMailIcon
              color={"var(--color-latex10)"}
              width={16}
              height={16}
            ></EnviarMailIcon>
            <p>Email</p>
          </div>
          <InputV1
            inputType="text"
            placeholderText={"nombreapellido@gmail.com"}
            errorStr={"El email es requerido"}
            onChange={onChangeInput}
            checkError={checkError}
            isRequired={true}
            name="email"
            value={formularioPerfil.email}
          />
        </InputContainer>
        <BtnSubirOrden
          className="bgc-primary c-white rb18m"
          onClick={() => subirOrden(formularioPerfil)}
        >
          Siguiente
        </BtnSubirOrden>
      </BodyEnviarOrden>
    </ContainerEnviarOrden>
  );
};

export default EnviarOrden;
